import { createContext, useContext } from 'react';
import type { RefObject } from 'react';

const ViewModelSVGRefContext = createContext<RefObject<SVGSVGElement | null> | null>(null);

export const ViewModelSVGRefContextProvider = ViewModelSVGRefContext.Provider;

export const useViewModelSVGRef = (): RefObject<SVGSVGElement | null> | null => {
  return useContext(ViewModelSVGRefContext);
};
